export default __webpack_public_path__ + "static/media/lightening1.3cc6ae3b.png";